var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox, Form, Input } from 'antd';
import axios from 'axios';
import styles from './Forms.module.scss';
import { useComponentLocale } from '../../hooks/useComponentLocale';
import { ErrorIcon } from "../../helpers/icons";
var RegistrationForm = function (_a) {
    var setIsSignUpFinishPage = _a.setIsSignUpFinishPage, openResetForm = _a.openResetForm;
    var _b = useState({
        email: '',
        password: '',
        confirmPass: '',
    }), inputControl = _b[0], setInputControl = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var getLocale = useComponentLocale();
    var termsLocale = getLocale({ component: 'login_form', section: 'accept_terms' });
    var confirmPassLocale = getLocale({ component: 'auth_page', section: 'confirm_pass' });
    var emailLocale = getLocale({ component: 'login_form', section: 'email' });
    var passwordLocale = getLocale({ component: 'login_form', section: 'createPassword' });
    var registrLocale = getLocale({ component: 'auth_page', section: 'sign_up_btn' });
    var inputEmailLocale = getLocale({ component: 'login_form', section: 'input_email' });
    var inputCorrectEmailLocale = getLocale({ component: 'login_form', section: 'input_correct_email' });
    var inputConfirmLocale = getLocale({ component: 'auth_page', section: 'input_confirm' });
    var inputPasswordLocale = getLocale({ component: 'login_form', section: 'input_password' });
    var confirmRejectedLocale = getLocale({ component: 'auth_page', section: 'confirm_reject' });
    var readAgreeLocale = getLocale({ component: 'login_form', section: 'read_agree' });
    var termsOfUseLocale = getLocale({ component: 'login_form', section: 'terms_of_use' });
    var andLocale = getLocale({ component: 'login_form', section: 'and' });
    var refundLocale = getLocale({ component: 'login_form', section: 'refund_policy' });
    var recoverPassLocale = getLocale({ component: 'login_form', section: 'recover_pass' });
    var userExistLocale = getLocale({ component: 'login_form', section: 'user_exist' });
    var handleInputControl = function (property, value) {
        var _a;
        setInputControl(__assign(__assign({}, inputControl), (_a = {}, _a[property] = value, _a)));
    };
    var handleOpenResetForm = function () { return openResetForm(true); };
    var finishRegistration = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var body, url, signUp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = new URLSearchParams();
                    body.append('x_referer', 'GTOBase');
                    body.append('x_name', value.username);
                    body.append('x_pswd', value.password);
                    body.append('x_conf_pswd', value.confirmPassword);
                    url = 'https://reserve.simplepostflop.com/signupn/signup.php';
                    setIsLoading(true);
                    return [4 /*yield*/, axios.post(url, body, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })];
                case 1:
                    signUp = _a.sent();
                    if (signUp.data.state === 'success') {
                        setIsSignUpFinishPage(true);
                        setIsLoading(false);
                    }
                    else {
                        setError(signUp.data.error_code);
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getErrorMessage = function (error) {
        if (error === 1003) {
            return (_jsx("div", { children: _jsxs("p", __assign({ className: styles.errorTextContainer }, { children: [_jsx("div", { children: _jsx(ErrorIcon, {}) }), _jsxs("div", __assign({ className: styles.errorText }, { children: [_jsx("h4", __assign({ className: styles.titleError }, { children: userExistLocale })), _jsx("div", { children: _jsx(Button, __assign({ className: styles.recoverPassword, type: 'link', onClick: handleOpenResetForm }, { children: recoverPassLocale })) })] }))] })) }));
        }
        if (error === 1002) {
            return (_jsx("div", { children: _jsxs("p", __assign({ className: styles.errorTextContainer }, { children: [_jsx("div", { children: _jsx(ErrorIcon, {}) }), _jsxs("div", __assign({ className: styles.errorText }, { children: [_jsx("h4", __assign({ className: styles.titleError }, { children: "The email address doesn't exist" })), _jsx("span", { children: "Please, input your relevant email address, that we can send you confirmation." })] }))] })) }));
        }
        return (_jsxs("p", __assign({ className: styles.errorTextContainer }, { children: [_jsx("div", { children: _jsx(ErrorIcon, {}) }), _jsx("div", { children: _jsx("h4", __assign({ className: styles.titleError }, { children: error })) })] })));
    };
    return (_jsxs(Form, __assign({ className: styles.formBody, onFinish: finishRegistration }, { children: [_jsxs("div", { children: [_jsx("span", { children: "Email" }), _jsx(Form.Item, __assign({ name: 'username', className: styles.formItemInputs, rules: [
                            { required: true, message: inputEmailLocale, validateTrigger: 'onSubmit' },
                            { type: 'email', message: inputCorrectEmailLocale, validateTrigger: 'onSubmit' },
                        ] }, { children: _jsx(Input, { placeholder: emailLocale, value: inputControl.email, className: styles.formInput, onChange: function (e) { return handleInputControl('email', e.target.value); } }) }))] }), _jsxs("div", __assign({ className: styles.marginTop }, { children: [_jsx("span", { children: "Password" }), _jsx(Form.Item, __assign({ name: 'password', className: styles.formItemInputs, rules: [{ required: true, message: inputPasswordLocale, validateTrigger: 'onSubmit' }] }, { children: _jsx(Input.Password, { placeholder: passwordLocale, value: inputControl.password, className: styles.formInput, onChange: function (e) { return handleInputControl('password', e.target.value); } }) }))] })), _jsxs("div", __assign({ className: styles.marginTop }, { children: [_jsx("span", { children: "Confirm password" }), _jsx(Form.Item, __assign({ name: 'confirmPassword', className: styles.formItemInputs, dependencies: ['password'], rules: [
                            {
                                required: true,
                                message: inputConfirmLocale,
                            },
                            function (_a) {
                                var getFieldValue = _a.getFieldValue;
                                return ({
                                    validator: function (_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(confirmRejectedLocale));
                                    },
                                });
                            },
                        ] }, { children: _jsx(Input.Password, { placeholder: confirmPassLocale, value: inputControl.confirmPass, className: styles.formInput, onChange: function (e) { return handleInputControl('confirmPass', e.target.value); } }) }))] })), _jsx(Form.Item, __assign({ name: 'terms', valuePropName: 'checked', className: [styles.formItemOther, styles.marginTop].join(' '), rules: [
                    {
                        validator: function (_, value) { return (value ? Promise.resolve() : Promise.reject(termsLocale)); },
                    },
                ] }, { children: _jsxs("div", __assign({ className: styles.checkboxContainer }, { children: [_jsx(Checkbox, {}), _jsxs("span", __assign({ className: styles.formCheckboxText }, { children: [readAgreeLocale, _jsx(Link, __assign({ to: '/docs/terms' }, { children: termsOfUseLocale })), andLocale, _jsx(Link, __assign({ to: '/docs/refund' }, { children: refundLocale }))] }))] })) })), _jsx(Form.Item, __assign({ className: [styles.formItemOther, styles.marginTop].join(' ') }, { children: _jsx(Button, __assign({ loading: isLoading, type: 'primary', size: 'middle', htmlType: 'submit', block: true, className: styles.formSubmitBtn }, { children: registrLocale })) })), error && _jsx(Form.Item, __assign({ style: { marginBottom: 0 } }, { children: getErrorMessage(error) }))] })));
};
export default RegistrationForm;
